const C = require("../constants");

const selectTicket = (data) => {
    return {
        type: C.TICKET_SELECT,
        data
    }
};

export {selectTicket};


// WEBPACK FOOTER //
// ./src/actions/TicketSelectActions.js